import React, { useState } from 'react';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    'form-name': 'contact',
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    phone: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  
    const form = e.target as HTMLFormElement;
    const formDataToSend = new FormData(form);
    
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formDataToSend as any).toString()
    })
      .then(() => {
        console.log("Form successfully submitted");
        setSubmitted(true);
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setSubmitted(false);
          setFormData({
            'form-name': 'contact',
            firstName: '',
            lastName: '',
            companyName: '',
            email: '',
            phone: ''
          });
        }, 3000);
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        alert('Errore nell\'invio del form. Riprova.');
      });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact-form" className="py-28 pt-22 md:py-48 md:pt-40 bg-primary from-primary via-primary to-secondary">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12 text-white">
              <h2 id="contact-form-title" className="text-4xl sm:text-4xl lg:text-5xl font-bold mb-6">
                Risparmia sui tuoi prossimi ordini. Inizia oggi.
              </h2>
            <p className="text-lg sm:text-xl text-blue-50 text-balance">
              Compila il form e ti contatteremo entro 24 ore
            </p>
          </div>

          <div className="bg-white rounded-3xl px-8 pb-8 pt-6 md:px-12 md:pb-12 shadow-2xl">
            {!submitted ? (
              <form name="contact"
              onSubmit={handleSubmit}
              className="space-y-6"
              netlify-honeypot="message">

                <input type="hidden" name="form-name" value="contact" />

                {/* Honeypot: input nascosto per anti-spam */}
                <div style={{ display: 'none' }}>
                  <label>
                    Non compilare questo campo:
                    <input name="message" type="text" tabIndex={-1} autoComplete="off" />
                  </label>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="firstName" className="block text-sm font-semibold text-gray-700 mb-2">
                      Nome *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                      placeholder="Mario"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="block text-sm font-semibold text-gray-700 mb-2">
                      Cognome *
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      required
                      value={formData.lastName}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                      placeholder="Rossi"
                    />
                  </div>
                </div>

                {/* Azienda */}
                <div>
                  <label htmlFor="companyName" className="block text-sm font-semibold text-gray-700 mb-2">
                    Azienda *
                  </label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    required
                    value={formData.companyName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                    placeholder="Nome della tua azienda"
                  />
                </div>

                {/* Email */}
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                    placeholder="email@esempio.com"
                  />
                </div>

                {/* Telefono */}
                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefono
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                    placeholder="+39 123 456 7890"
                  />
                </div>

                {/* Submit Button */}
                <div>
                  <button
                    type="submit"
                    className="w-full bg-primary text-white px-8 py-4 mt-4 rounded-full font-semibold text-lg hover:bg-primary/90 transition-colors duration-300"
                  >
                    Unisciti a Synergy
                  </button>
                </div>
                {/* 
                <p className="text-sm text-gray-500 text-center mt-4">
                  * Campi obbligatori
                </p> */}
              </form>
            ) : (
              <div className="text-center py-12">
                <div className="w-20 h-20 bg-tertiary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-tertiary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Grazie per il tuo interesse!</h3>
                <p className="text-gray-600">Ti contatteremo entro 24 ore.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
